import { ICreateEditPermission, ICreateUserPermissionsSignature, IEditPermission } from 'types';

import { STXAxiosInstance } from '../Axios/STXAxiosInstance';

export const createPermissionsSignature = async (
  item: ICreateEditPermission,
  network: 'stx:testnet' | 'stx:mainnet'
) =>
  STXAxiosInstance.post<ICreateEditPermission>(`permissions/${network}`, { ...item }).then(
    (data) => data.data
  );

export const getCreatedPermissions = async (
  vault: string,
  network: 'stx:testnet' | 'stx:mainnet'
) =>
  STXAxiosInstance.get<{ data: IEditPermission[] }>(`permissions/${network}/${vault}`).then(
    (data) => data.data.data
  );

export const addPermissionsSignature = async (
  item: ICreateUserPermissionsSignature,
  network: 'stx:testnet' | 'stx:mainnet'
) =>
  STXAxiosInstance.put<ICreateUserPermissionsSignature>(`permissions/${network}`, { ...item }).then(
    (data) => data.data
  );
